import { ThemeProvider } from 'next-themes'
import { PropsWithChildren } from 'react'

import { ThemeShortcut } from '@/components/theme-shortcut'
import { DocumentPreviewProvider } from '@/contexts/document-preview-context'
import { FirebaseUserContextProvider } from '@/hooks/useFirebaseUser'
import { initI18n } from '@/i18n'
import { useDateFnsConfiguration } from '@/integrations/date-fns'
import { useZodLocale } from '@/integrations/zod'

import { QueryProvider } from './QueryProvider'
import { ReduxProvider } from './ReduxProvider'

initI18n()

export const Providers = ({ children }: PropsWithChildren) => {
  useZodLocale()
  useDateFnsConfiguration()

  return (
    <ThemeProvider attribute="class" enableSystem={false} forcedTheme="light">
      <ThemeShortcut />
      <ReduxProvider>
        <QueryProvider>
          <FirebaseUserContextProvider>
            <DocumentPreviewProvider>{children}</DocumentPreviewProvider>
          </FirebaseUserContextProvider>
        </QueryProvider>
      </ReduxProvider>
    </ThemeProvider>
  )
}
